import { useMemo } from 'react';

import { toBase64 } from '@change-corgi/core/base64';
import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import { usePsfPromoteOrSharePageData } from 'src/app/pages/psf/promoteOrShare/pageContext';
import { PSF_COMBO_QUERY_PARAM_DATA_NAME } from 'src/app/shared/utils/bandits';

import { genPsfComboData } from './genPsfComboData';

type Result = ModelHookResult<{
	query?: Record<string, string>;
}>;

export function useEncodedBanditDataForUrl(): Result {
	const { data: pageData } = usePsfPromoteOrSharePageData();
	const { errorReporter } = useUtilityContext();

	return {
		data: {
			query: useMemo(() => {
				const data = genPsfComboData(pageData);
				try {
					return data
						? {
								[PSF_COMBO_QUERY_PARAM_DATA_NAME]: toBase64(JSON.stringify(genPsfComboData(pageData))),
							}
						: undefined;
				} catch (e) {
					void errorReporter.report({
						error: new Error('PSF promote_or_share: failed to encode bandit data for url', { cause: e }),
						params: {
							data,
						},
					});
					return undefined;
				}
			}, [pageData, errorReporter]),
		},
	};
}
